export const pageLoadErrorMessage = "Något gick fel när sidan laddades. Vänligen uppdatera sidan och försök igen. Kontakta support om problemet kvarstår."
